import React from 'react';
import { SINGLE_VALUE } from '@/components/ChartHolder.constants';
import { useHandleDisabledPresentationClick } from '@/features/dataPresentation/navigation/connected-buttons/hooks';
import { TABLE } from '@/components/charting/chartType.constants';
import { useDataPresentationParam } from '@/hooks';
import { SingleValue as SingleValueBase } from '../buttons';
import { useNavigateToDataPresentation } from './useNavigateToDataPresentation';

export const SingleValue: React.FC<{ available: boolean }> = ({
  available,
}) => {
  const dataPresentation = useDataPresentationParam();
  const handleDisabledClick = useHandleDisabledPresentationClick(TABLE);
  const navigate = useNavigateToDataPresentation(SINGLE_VALUE);

  return (
    <SingleValueBase
      onClick={available ? navigate : handleDisabledClick}
      $active={dataPresentation === SINGLE_VALUE}
      $static={!available}
    />
  );
};
